import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appDialogTemplateInjector]'
})
export class DialogTemplateInjectorDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
